import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../Translations';

interface Props {
  completedCount: number;
  remainingCount: number;
}
const ModulesCompletedSome: React.FC<Props> = ({ completedCount, remainingCount }) => {
  return (
    <span data-test-modules-completed={completedCount}>
      <T
        kind="{{count}} module completed, {{remainingCount}} remaining"
        count={completedCount}
        remainingCount={remainingCount}
      />
    </span>
  );
};

export default observer(ModulesCompletedSome);
